module.exports = __webpack_public_path__ + "img/buettner_mpp_440.b8b70bd1.png";